import { BLOGS_IMAGES } from "../images/blogs";

export const blogsContent = [
    {
    alt: "tesla_overlay",
    projectUrl: "Card Title",
    publishedOn:"07/20/2025",
    hoverMsg: "hover-msg",
    blogTitle: "React Native’s New Architecture: Why It Matters ",
    blogDes: "In this blog post, we will take a deep dive into how React Native’s new architecture works and why it matters for developers. We’ll discuss concepts like the Fabric renderer, TurboModules, and the JSI ...",
    imgBackground: BLOGS_IMAGES.RN_ARCH,
    blogTechStack: [
      "JavaScript",
      "React Native",
      "New Architecture",
      "Fabric Renderer",
      "TurboModules",
      "JSI",
    ],
    link: "https://medium.com/@nadgmo/react-natives-new-architecture-why-it-matters-298af03e6d28",
  },
  {
    alt: "tesla_overlay",
    projectUrl: "Card Title",
    publishedOn:"06/11/2023",
    hoverMsg: "hover-msg",
    blogTitle: "JavaScript Closures Made Easy: A Guide for Beginners 🔥🔥. ",
    blogDes: "In this blog post, we will take a deep dive into how JavaScript functions really work. We’ll discuss concepts like higher-order functions (HOF), execution context ...",
    imgBackground: BLOGS_IMAGES.closures_blog,
    blogTechStack: [
      "JavaScript",
      "Closures",
      "Higher order functions",
      "Execution Context",
      "Lexical Environment",
    ],
    link: "https://medium.com/@nadgmo/javascript-closures-made-easy-a-guide-for-beginners-2821c5642d88",
  },
  {
    alt: "tesla_overlay",
    projectUrl: "Card Title",
    publishedOn:"05/06/2023",
    hoverMsg: "hover-msg",
    blogTitle: "Tips and Tricks for Optimizing React Native Performance . ",
    blogDes: "Optimizing an app’s performance is critical for ensuring a seamless user experience and satisfying client expectations ...",
    imgBackground: BLOGS_IMAGES.RN_Optimization,
    blogTechStack: [
      "JavaScript",
      "Closures",
      "Higher order functions",
      "Execution Context",
      "Lexical Environment",
    ],
    link: "https://medium.com/@nadgmo/optimizing-react-native-techniques-for-better-performance-1ebeb9cc9841",
  },
  {
    alt: "tesla_overlay",
    projectUrl: "Card Title",
    publishedOn:"03/15/2023",
    hoverMsg: "hover-msg",
    blogTitle: "A Beginner’s Guide to JavaScript Map and Set Data Structures . ",
    blogDes: "we’ll cover the essentials of using these powerful data structures, including their benefits and practical applications .",
    imgBackground: BLOGS_IMAGES.SET_MAP_BLOG,
    blogTechStack: [
      "JavaScript",
      "Closures",
      "Higher order functions",
      "Execution Context",
      "Lexical Environment",
    ],
    link: "https://medium.com/@nadgmo/a-beginners-guide-to-javascript-map-and-set-data-structures-7707909cfa3f",
  },
  {
    alt: "tesla_overlay",
    projectUrl: "Card Title",
    publishedOn:"03/28/2024",
    hoverMsg: "hover-msg",
    blogTitle: "For Web Devs : how browsers work ! ",
    blogDes: "we’ll cover the essentials of using these powerful data structures, including their benefits and practical applications .",
    imgBackground: BLOGS_IMAGES.BROWSER_WORKS,
    blogTechStack: [
      "JavaScript",
      "Closures",
      "Higher order functions",
      "Execution Context",
      "Lexical Environment",
    ],
    link: "https://medium.com/@nadgmo/for-web-devs-how-browsers-work-2ac93b7b23df",
  },
];
